import {User} from '@/src/entities/user'

export const checkRequirementUserRules = (user: Nullable<User>) => {
    if (!user) {
        return true
    }

    if (!user.name || !user.last_name || !user.email || !user.birthday) {
        return false
    }

    return true
}